import React from "react";

import "./style.css";

export interface TextFieldProps {
  id: string;
  placeholder?: string;
  type: string;
  options?: string[];
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  customClass?: string;
  isRequired?: boolean;
  pattern?: string;
  errorMsg?: string;
  maxLength?: number;
  minLength?: number;
}

const TextField = (props: TextFieldProps) => {
  return (
    <div className="w-full px-4">
      <div className="flex justify-between mb-2 items-center">
        <span>
          <span
            className={`font-bold ${props.errorMsg ? "text-primary-red" : "text-grey-scale-slate"}`}
          >
            {props.label}
          </span>
          {props.isRequired && (
            <span className="font-bold text-accent-berry">*</span>
          )}
        </span>
        {props.errorMsg && (
          <span className="text-primary-red text-sm italic">
            {props.errorMsg}
          </span>
        )}
      </div>
      <input
        data-track={`input-${props.id}`}
        data-testid="custom-textfield"
        aria-describedby={props.label}
        id={props.id}
        name={props.id}
        type={props.type}
        value={props.value}
        onChange={props.onChange}
        className={`field ${props.customClass ? props.customClass : ""} ${props.errorMsg ? "!border-primary-red" : ""}`}
        required={props.isRequired}
        pattern={props.pattern}
        maxLength={props.maxLength}
        minLength={props.minLength}
      />
    </div>
  );
};

export default TextField;
